import AdminLayout from "../../../components/admin/layout/AdminLayout";
import Surveyors from "../../../components/common/surveyor/SurveyorList";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyorListPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <Surveyors />
    </AdminLayout>
  );
}

export default SurveyorListPage;
